export default __webpack_public_path__ + "static/media/Slide39.262c96ea.PNG";